import Trix from "trix";
import { yellow } from "tailwindcss/colors";

// text colors
Trix.config.textAttributes.black = {
  style: { color: "#000" },
  parser: function (element) {
    return element.style.color === "#000";
  },
  inheritable: true,
};

Trix.config.textAttributes.red = {
  style: { color: "#DC2626" },
  parser: function (element) {
    return element.style.color === "#DC2626";
  },
  inheritable: true,
};

Trix.config.textAttributes.blue = {
  style: { color: "#3B82F6" },
  parser: function (element) {
    return element.style.color === "#3B82F6";
  },
  inheritable: true,
};

Trix.config.textAttributes.lime = {
  style: { color: "#65a30d" },
  parser: function (element) {
    return element.style.color === "#65a30d";
  },
  inheritable: true,
};

// font sizes
Trix.config.textAttributes.greater = {
  style: { fontSize: "22px" },
  parser: function (element) {
    return element.style.fontSize === "22px";
  },
  inheritable: true,
};

Trix.config.textAttributes.great = {
  style: { fontSize: "20px" },
  parser: function (element) {
    return element.style.fontSize === "20px";
  },
  inheritable: true,
};

Trix.config.textAttributes.medium = {
  style: { fontSize: "16px" },
  parser: function (element) {
    return element.style.fontSize === "16px";
  },
  inheritable: true,
};

Trix.config.textAttributes.small = {
  style: { fontSize: "12px" },
  parser: function (element) {
    return element.style.fontSize === "12px";
  },
  inheritable: true,
};

// font styles
Trix.config.textAttributes.heading1 = {
  style: { fontSize: "22px", fontWeight: "bold" },
  parser: function (element) {
    return element.style.fontSize === "30px";
  },
  inheritable: true,
};

// insert the color buttons visual in the default toolbar
addEventListener("trix-initialize", function (event) {
  var ColorButtons =
    '<button class="trix-button trix-button--icon" data-trix-attribute="black"><p class="trix-button--color trix-button--color-black">&nbsp;</p></button>' +
    '<button class="trix-button trix-button--icon" data-trix-attribute="red"><p class="trix-button--color trix-button--color-red">&nbsp;</p></button>' +
    '<button class="trix-button trix-button--icon" data-trix-attribute="blue"><p class="trix-button--color trix-button--color-blue">&nbsp;</p></button>' +
    '<button class="trix-button trix-button--icon" data-trix-attribute="lime"><p class="trix-button--color trix-button--color-lime">&nbsp;</p></button>';

  event.target.toolbarElement
    .querySelector(".trix-button-group")
    .insertAdjacentHTML("beforeend", ColorButtons);
});

// insert font size buttons
addEventListener("trix-initialize", function (event) {
  var fontSizeButtons =
    '<button class="trix-button trix-button--icon trix-button--font-size" data-trix-attribute="greater"><p class="text-xl trix-button--label">A</p></button>' +
    '<button class="trix-button trix-button--icon trix-button--font-size" data-trix-attribute="great"><p class="text-md trix-button--label" style="padding-top: 0.19rem">A</p></button>' +
    '<button class="trix-button trix-button--icon trix-button--font-size" data-trix-attribute="medium"><p class="text-sm trix-button--label" style="padding-top: 0.28rem">A</p></button>' +
    '<button class="trix-button trix-button--icon trix-button--font-size" data-trix-attribute="small"><p class="text-xs trix-button--label" style="padding-top: 0.39rem">A</p></button>';

  event.target.toolbarElement
    .querySelector(".trix-button-group")
    .insertAdjacentHTML("beforeend", fontSizeButtons);
});

// Block file upload
window.addEventListener("trix-file-accept", function (event) {
  event.preventDefault();
  alert("Dodawanie załączników jest niedozwolone" + "\n" + "File attachment not supported!");
});
